import styled from '@emotion/styled';
import { Button as _Button, Typography } from '@material-ui/core';
import { DateTime } from 'luxon';
import { createElement, useContext } from 'react';
import { FormattedHTMLMessage, FormattedMessage } from 'react-intl';
import { useRecoilValue } from 'recoil';

import theme from '../../../../theme';
import Spinner from '../../../component/compound/Spinner';
import { SPACING_HUGE, SPACING_LARGE, SPACING_REGULAR, SPACING_UNIT } from '../../../constant/spacing';
import { context as HistoryContext } from '../../../context/history';
import { context as StateContext } from '../../../context/state';
import { flexibleLayoutContainer } from '../../../styleUtility/flexibleLayout';
import mq from '../../../styleUtility/mediaquery';
import { projectAtom, projectLoadingAtom } from '../atoms/projectAtom';

const SubmitCompletionScreen = () => {
  const project = useRecoilValue(projectAtom);
  const isLoading = useRecoilValue(projectLoadingAtom);
  const { language } = useContext(StateContext);
  const history = useContext(HistoryContext);

  const deliveryDueDate = project ? project.creationSet?.deliveryDueDate : null;

  if (isLoading) return <Spinner fullHeight />;

  return (
    <Root>
      <Content>
        <Title variant="h6">
          <FormattedMessage id="project_editing_page.for_completion.title" />
        </Title>
        <Typography>
          {deliveryDueDate ? (
            <FormattedHTMLMessage
              id="project_editing_page.for_completion.text"
              values={{
                deliveryDueDate:
                  language === 'ja-JP'
                    ? DateTime.fromISO(deliveryDueDate).toFormat('M月d日')
                    : DateTime.fromISO(deliveryDueDate).toFormat('MMMM d'),
              }}
            />
          ) : (
            <FormattedHTMLMessage id="project_editing_page.for_completion.text_no_due" />
          )}
        </Typography>
        <Picture>
          <img src="/assets/submission_complete.svg" alt="Project successfully submitted" />
        </Picture>
      </Content>
      <ButtonWrap>
        <Button variant="contained" color="primary" onClick={() => history.push('/projects')}>
          <FormattedMessage id="project_editing_page.for_completion.back" />
        </Button>
      </ButtonWrap>
    </Root>
  );
};

const Root = styled('div')`
  padding: ${SPACING_HUGE}px calc((100% - 976px) / 1.5) ${SPACING_UNIT * 10}px;
`;

const Title = styled(Typography)`
  margin-bottom: ${SPACING_UNIT * 3}px;
`;

const Content = styled('div')`
  padding: ${SPACING_LARGE}px;
  background-color: #fff;
  border-radius: ${theme.shape.borderRadius}px;
  margin-bottom: ${SPACING_REGULAR}px;
`;

const Picture = styled('div')`
  ${flexibleLayoutContainer({ direction: 'row', alignItems: 'center', justifyContent: 'center' })}
  margin-top: ${SPACING_HUGE}px;
  > img {
    max-width: 640px;
    ${mq('sp')} {
      max-width: 100%;
      object-fit: contain;
    }
  }
`;

const ButtonWrap = styled('div')`
  ${mq('sp')} {
    padding: 0 16px;
  }
`;

const Button = styled(_Button)`
  ${mq('sp')} {
    width: 100%;
  }
`;

export default SubmitCompletionScreen;
